import type { Dictionary } from "./types";

export const en = {
  meta: {
    title: "Qurtuba Front | Register Your Interest in Offices on Airport Road",
    description:
      "Offices for lease at Qurtuba Front on Airport Road, Riyadh. Register your interest and the project team will contact you with available spaces and leasing details.",
    ogLocale: "en_US",
    htmlLang: "en",
  },
  brand: {
    projectName: "Qurtuba Front",
    projectCaption: "Offices for annual lease",
  },
  header: {
    cta: "Register Your Interest",
  },
  media: {
    title: "Qurtuba Front — Project Gallery",
    video: "Project Video",
    brochure: "Brochure",
    brochureMobile: "PDF Brochure",
    platform: "Interactive Platform",
    location: "Project Location",
    whatsappTitle: "Chat with Bond on WhatsApp",
    whatsappSubtitle: "Ask about available office spaces",
  },
  form: {
    title: "Register Your Interest",
    intro:
      "Share your details and our project team will contact you with available office spaces and leasing details.",
    fullName: "Full Name",
    fullNamePlaceholder: "Enter your name",
    phone: "Mobile Number",
    phonePlaceholder: "+966",
    email: "Email Address",
    emailPlaceholder: "name@company.com",
    company: "Company / Organisation",
    companyPlaceholder: "Enter the company or organisation",
    area: "Required Area",
    areaPlaceholder: "Select area (optional)",
    notes: "Notes or Special Requirements",
    notesPlaceholder: "Add any details that help us understand your requirements",
    submit: "Register Your Interest",
    privacy:
      "Your information will be used to contact you regarding office leasing at Qurtuba Front. We use Microsoft Clarity to analyse site usage and improve it, and it may set cookies for that purpose.",
    submitting: "Registering your interest...",
  },
  submitState: {
    errorHeading: "We could not send your details",
    errorBody: "Something went wrong while sending. Try again, or contact us directly.",
    retry: "Try again",
    finalHeading: "We still could not send your details",
    finalBody:
      "Please contact us directly through one of the channels below and we will help you complete your registration.",
    contactTitle: "Contact us",
    edit: "Edit details",
  },
  social: {
    whatsapp: "WhatsApp",
    instagram: "Instagram",
    linkedin: "LinkedIn",
  },
  area: {
    lt200: "Less than 200 m²",
    "200_500": "200-500 m²",
    "500_1000": "500-1,000 m²",
    gt1000: "More than 1,000 m²",
    undecided: "Not decided yet",
  },
  errors: {
    required: "This field is required.",
    tooShort: "This name is too short.",
    tooLong: "This value is too long.",
    invalidPhone: "Enter a valid Saudi mobile number.",
    invalidEmail: "Enter a valid email address.",
    invalidArea: "Choose an area from the options.",
  },
  stats: {
    parking: {
      value: "300+",
      label: "Parking",
      title: "300+ Parking Spaces",
      caption: "Parking for tenants and visitors",
    },
    airport: {
      value: "Airport",
      label: "Road",
      title: "Airport Road",
      caption: "Direct frontage on a major corridor",
    },
    metro: {
      value: "Metro",
      label: "Near",
      title: "Near the Metro",
      caption: "Better connectivity across Riyadh",
    },
  },
  features: {
    operational: { title: "Operational Services", caption: "To the highest standards" },
    flexible: { title: "Flexible Spaces", caption: "Designed for your business" },
    prime: { title: "Prime Location", caption: "On Airport Road" },
  },
  location: {
    title: "Strategic Business Location",
    body: "Located in Qurtuba District on Airport Road, offering easy access to business districts and the airport, with close proximity to the Riyadh Metro line.",
    bullets: [
      "Direct frontage on Airport Road",
      "Near the Riyadh Metro line",
      "Qurtuba District, northeast Riyadh",
    ],
  },
  footer: {
    developer: "Developer & Contractor",
  },
  success: {
    heading: "Thank you for your interest",
    message:
      "We've received your enquiry about Qurtuba Front.\nOur team will contact you with available office spaces\nand leasing details.",
    backHome: "Back to home",
    footerNote: "Qurtuba Front · Airport Road, Riyadh",
  },
  a11y: {
    skipToForm: "Skip to the registration form",
    whatsapp: "Chat with Bond on WhatsApp",
  },
} satisfies Dictionary;
